import { SET_ACCEPT_AGREEMENT_START, SET_ACCEPT_AGREEMENT_FULFILLED, SET_ACCEPT_AGREEMENT_REJECTED } from './actionTypes';

const initialState = {
  acceptAgreementError: null,
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACCEPT_AGREEMENT_START:
      return {
        ...state,
        acceptAgreementError: null,
      };
    case SET_ACCEPT_AGREEMENT_FULFILLED:
      return {
        ...state,
        acceptAgreementError: null,
      };
    case SET_ACCEPT_AGREEMENT_REJECTED:
      return {
        ...state,
        acceptAgreementError: action.payload,
      };
    default:
      return state;
  }
}
